var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a4 4 0 0 0 4-4V8a2 2 0 0 0-2-2h-8L8 4H2Z",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 12.048A2 2 0 0 1 4.98 11h17.44a1.58 1.58 0 0 1 1.372 2.364l-3.216 5.628A2 2 0 0 1 18.839 20H1.596a1.596 1.596 0 0 1-1.404-2.355l3.029-5.597Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderOpen);
export default __webpack_public_path__ + "static/media/ic_action_folder_open.89a2973d2a1dd5a5bcd08a3cddc17a5b.svg";
export { ForwardRef as ReactComponent };